import { IAppVersionState, IAppVersion } from '../../states/containersState';
import * as application from '../../actions/containers/application';
import * as _ from 'lodash';
import { ActionTypes } from '../../actions/containers/application';

const initialState: IAppVersionState = {
  version: {
    semver: '',
    isNewAvailable: false,
    checkingForVersion: false
  }
};

export function applicationVersionReducer(state: IAppVersionState = initialState,
                                   action: application.Actions): IAppVersionState {
    switch (action.type) {
        case application.ActionTypes.APP_CHECK_VERSION: {
          const version = Object.assign({}, state.version, {
            checkingForVersion: true
          });
          return Object.assign({}, state, { version });
        }
        case application.ActionTypes.APP_RECEIVED_VERSION: {
          const version = getVersion(state, action.payload);
          return Object.assign({}, state, { version });
        }
        default:
          return Object.assign({}, initialState, state);
    }
};

export const getApplicationVersion = (appVersionState: IAppVersionState) => appVersionState.version;

function getVersion(state: IAppVersionState, packageJson: any): IAppVersion {
  const currentVersion = state.version.semver;

  const remoteVersion = packageJson.version;
  const version: IAppVersion = {
    semver: '',
    isNewAvailable: state.version.isNewAvailable,
    checkingForVersion: false
  };

  const isCurrentVersionEmpty = '' === currentVersion;
  const isCurrentDifferentFromRemote = !isCurrentVersionEmpty && currentVersion !== remoteVersion;
  if (isCurrentVersionEmpty) {
    version.semver = remoteVersion;
  }
  if (isCurrentDifferentFromRemote) {
    version.semver = currentVersion;
    version.isNewAvailable = true;
  } else {
    // upgrade is completed
    version.semver = remoteVersion;
    version.isNewAvailable = false;
  }
  return version;
}



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/containers/appVersion.reducer.ts